import React from 'react';
// import { nanoid } from '@reduxjs/toolkit';
// components
import MNPGV2 from "@/components/MainPageLayouts/components/MNPGV2";
// hooks
import useMainPageItems from '@/hooks/useMainPageItems';
// types
import { TFooterComponent } from './type';


// const unqKey:string = nanoid(12);

const Footer = ( props:TFooterComponent ) => {
    console.log("Footer.rendered: ", props);

    // const footerTemplates = useMainPageItems({unqKey:unqKey, mapLayoutName:["MNPGGRP_002"]});
    const footerTemplates = useMainPageItems({mapLayoutName:"MNPGGRP_002"});

    if ( !footerTemplates ) return null;

    return (
        <footer className="footer-section section-bg fix">
            <MNPGV2 templates={footerTemplates} mapLayoutName={"MNPGGRP_002"} />
        </footer>
    )
}

const Component = React.memo(Footer, (prevProps: TFooterComponent, nextProps: TFooterComponent) => {
    console.log("Footer.memo", { prevProps, nextProps });
    return true;
});

export default Component;
